import React, { useEffect, useState } from 'react';
import PDFViewer from '../Files/documents/PDFViewer';
import PdfSkeleton from './PdfSkeleton';
import MarkdownSkeleton from './MarkdownSkeleton';

interface FileReaderComponentProps {
  fileUrl: string;
  fileType: string;
}

const FileReaderComponent: React.FC<FileReaderComponentProps> = ({ fileUrl, fileType }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [viewerUrl, setViewerUrl] = useState<string | null>(null);

  useEffect(() => {
    const processFile = () => {
      const lowerFileType = fileType.toLowerCase();

      if (lowerFileType.includes('pdf')) {
        setViewerUrl(fileUrl);
      } else if (lowerFileType.includes('image')) {
        setViewerUrl(fileUrl);
      } else if (lowerFileType.includes('word') || lowerFileType.includes('doc')) {
        setViewerUrl(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`);
      } else {
        setViewerUrl(fileUrl);
      }
      setIsLoading(false);
    };
    processFile();
  }, [fileUrl, fileType]);

  if (isLoading) {
    if (fileType.toLowerCase().includes('pdf')) {
      return <PdfSkeleton />;
    } else if (fileType.toLowerCase().includes('image')) {
      return <MarkdownSkeleton />;
    } else {
      return <div className="animate-fadePulse h-64 bg-gray-200 dark:bg-gray-700 rounded"></div>;
    }
  }

  return (
    <div className="h-[calc(100vh-200px)] min-w-[calc(100vw-200px)] mx-auto mt-6">
      {fileType.toLowerCase().includes('pdf') ? (
        <PDFViewer pdfUrl={viewerUrl!} />
      ) : fileType.toLowerCase().includes('image') ? (
        <img src={viewerUrl!} alt="Attachment" className="max-w-full h-auto" />
      ) : (
        <iframe
          src={viewerUrl!}
          title="Document Viewer"
          className="w-full h-full"
          frameBorder="0"
        />
      )}
    </div>
  );
};

export default FileReaderComponent;